export const COUNTRY_LIST = [
    { id: 'CAN', name: 'Canada', currency: 'CAD', symbol:'CAN' },
    { id: 'USA', name: 'United States', currency: 'USD', symbol:'USA' },
    { id: 'HKG', name: 'Hong Kong SAR', currency: 'HKD', symbol:'HKG' },
];